import { createLazyResolver } from 'owa-lazy-resolver';

export const lazyCreateDraftWeb = createLazyResolver(
    'MUTATION_CREATE_DRAFT_WEB',
    () => import(/* webpackChunkName: "CreateDraftWeb"*/ './queries/createDraftWeb'),
    m => m.createDraftWeb
);
